import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './ActionsButtons.styles';

import { Icon } from '@/components/Icon';

type ActionsButtonsProps = {
  onEdit: () => void;
  onSave: () => void;
  hasChanges: boolean;
  isSaving: boolean;
};

export const ActionsButtons: React.FC<ActionsButtonsProps> = ({
  onEdit,
  onSave,
  hasChanges,
  isSaving
}) => {
  const { t } = useTranslation('AcademyDetailTranslations');

  return (
    <Wrapper>
      {hasChanges && (
        <Button type="primary" onClick={onSave} loading={isSaving}>
          {t('SAVE_CHANGES')}
        </Button>
      )}
      <Button icon={<Icon i="Edit" />} onClick={onEdit} disabled={isSaving}>
        {t('EDIT')}
      </Button>
    </Wrapper>
  );
};
